/* @flow */
import BoxBody from 'components/BoxBody.jsx';
import Button from 'components/Button.jsx';
import Buttons from 'components/Buttons.jsx';
import ConfirmDialog from 'components/ConfirmDialog.jsx';
import Container from 'components/Container.jsx';
import Dialog from 'components/Dialog.jsx';
import Field from 'components/Field.jsx';
import Label from 'components/Label.jsx';
import Radio from 'components/Radio.jsx';
import PropTypes from 'prop-types';
import * as React from 'react';
import ModalTrigger from 'components/ModalTrigger.jsx';
import Textarea from 'components/Textarea.jsx';
import { ReportOptions, ReportOtherOption } from 'constants/ReportConstants';

type State = {
  selected: string,
  notes: string,
};

class ReportToRemindSelectModal extends React.Component<$FlowFixMeProps, State> {
  static propTypes = {
    reportee: PropTypes.string.isRequired,
    title: PropTypes.string,
    optionsMap: PropTypes.object,
    notesPlaceholder: PropTypes.string,
    notesRequired: PropTypes.bool,
    buttonText: PropTypes.string,
    onCancel: PropTypes.func,
    onReport: PropTypes.func.isRequired,
    onRequestHide: PropTypes.func,
  };

  static defaultProps = {
    title: 'Report to Remind',
    optionsMap: ReportOptions,
    notesPlaceholder: 'Why are you reporting this person?',
    notesRequired: false,
    buttonText: 'Report',
  };

  state: State = {
    selected: '',
    notes: '',
  };

  cancelConfirmDialog = () => {
    if (this.props.onCancel) {
      this.props.onCancel();
    }
    this.props.onRequestHide();
  };

  missingNotes = () => {
    return (
      (this.props.notesRequired || this.state.selected === ReportOtherOption) &&
      this.state.notes === ''
    );
  };

  reportClicked = () => {
    const { onRequestHide, onReport } = this.props;

    if (onRequestHide) {
      onRequestHide();
    }

    const key = this.state.selected;

    return onReport(key, this.state.notes);
  };

  renderConfirmDialog = () => {
    return (
      <ConfirmDialog
        eventScreenName="ReportToRemindSelectModal"
        title={`Are you sure you want to report ${this.props.reportee} to Remind?`}
        subtext="We review all reports and handle them based on our guidelines.
          Thank you for helping to keep our community safe."
        actionButtonText="Report"
        cancelButtonText="Cancel"
        onConfirm={this.reportClicked}
      />
    );
  };

  renderOption = (option: string, index: number) => {
    const { optionsMap } = this.props;
    return (
      <Radio
        name="report-message"
        checked={this.state.selected === option}
        onChange={() => this.setState({ selected: option })}
        key={index}>
        {optionsMap[option]}
      </Radio>
    );
  };

  handleTextChange = (event: SyntheticEvent<HTMLTextAreaElement>) => {
    this.setState({ notes: event.currentTarget.value });
  };

  render() {
    const subtext = `Why are you reporting ${this.props.reportee}?`;
    const confirmDialog = this.renderConfirmDialog();
    let notesPlaceholder = this.props.notesPlaceholder;

    if (this.props.notesRequired) {
      notesPlaceholder = `${this.props.notesPlaceholder} (Required)`;
    } else if (subtext === this.props.notesPlaceholder) {
      notesPlaceholder = '';
    }

    return (
      <Dialog
        {...this.props}
        size="small"
        className="ReportToRemindSelectModal"
        title={this.props.title}
        subtext={subtext}>
        <BoxBody divided>
          {this.props.children}
          <form>
            <Field>
              <Label>Reason</Label>
              {Object.keys(this.props.optionsMap).map(this.renderOption)}
              <Radio
                name="report-message"
                checked={this.state.selected === ReportOtherOption}
                onChange={() => this.setState({ selected: ReportOtherOption })}>
                Other
              </Radio>
            </Field>
            <Field>
              <Label>Notes</Label>
              <Textarea
                name="notes"
                value={this.state.notes}
                placeholder={notesPlaceholder}
                required={this.props.notesRequired}
                rows={2}
                onChange={this.handleTextChange}
              />
            </Field>
          </form>
          <Container size="xxsmall">
            <Buttons full>
              <Button level="secondary" onClick={this.cancelConfirmDialog}>
                Cancel
              </Button>
              <ModalTrigger modal={confirmDialog}>
                <Button disabled={this.missingNotes()}>{this.props.buttonText}</Button>
              </ModalTrigger>
            </Buttons>
          </Container>
        </BoxBody>
      </Dialog>
    );
  }
}

export default ReportToRemindSelectModal;
